import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SnapshotComponent } from './snapshot/snapshot.component';
import { SnapshotConfiguarationComponent } from './snapshot-configuaration/snapshot-configuaration.component';
import { SnapshotPreviewComponent } from './snapshot-preview/snapshot-preview.component';
import { ChartOutputComponent } from './chart-output/chart-output.component';
import { BarchartComponent } from './modules/barchart/barchart/barchart.component';
import { BarChartComponentCustom } from './custom-snapshot-chart-modules/barchart/barchart/barchart.component';
import { MsalGuard } from '@azure/msal-angular';
//import { MsalGuardCustom } from '../../core/sso/config/msal.guard';
import { AppConstants } from './Constant/app-constants';
import { StackedBarChartComponent } from './modules/stacked-bar-chart/stacked-bar-chart/stacked-bar-chart.component';

import { PieChartComponent } from './modules/pie-chart/pie-chart/pie-chart.component';
import { ScatterChartComponent } from './modules/scatter-chart/scatter-chart/scatter-chart.component';
import { LollipopChartComponent } from './modules/lollipop-chart/lollipop-chart/lollipop-chart.component';
import { UniqueChartComponent } from './modules/unique-chart/unique-chart/unique-chart.component';
import { AreaChartComponent } from './modules/area-chart/area-chart/area-chart.component';
import { LineOrTrendChartConstants } from './Constant/line-or-trend-chart-constants';
import { LineOrTrendChartComponent } from './modules/line-or-trend-chart/line-or-trend-chart/line-or-trend-chart.component';
import { OutputviewComponent } from './outputview/outputview.component';
import { StackedBarChartComponentCustom } from './custom-snapshot-chart-modules/stacked-bar-chart/stacked-bar-chart/stacked-bar-chart.component';
import { PieChartComponentCustom } from './custom-snapshot-chart-modules/pie-chart/pie-chart/pie-chart.component';
import { AreaChartComponentCustom } from './custom-snapshot-chart-modules/area-chart/area-chart/area-chart.component';
import { ScatterChartComponentCustom } from './custom-snapshot-chart-modules/scatter-chart/scatter-chart/scatter-chart.component';
import { LollipopChartComponentCustom } from './custom-snapshot-chart-modules/lollipop-chart/lollipop-chart/lollipop-chart.component';
import { UniqueChartComponentCustom } from './custom-snapshot-chart-modules/unique-chart/unique-chart/unique-chart.component';
import { LineOrTrendChartComponentCustom } from './custom-snapshot-chart-modules/line-or-trend-chart/line-or-trend-chart/line-or-trend-chart.component';
import { CustomOutputviewComponent } from './CUSTOM-output/custom-outputview/custom-outputview.component';
import { TableViewComponent } from './custom-snapshot-chart-modules/tableView/tableView/table-view-component';

const routes: Routes = [
  {path:'', component:SnapshotComponent},
  {path:'configuaration', component:SnapshotConfiguarationComponent},
  {path:'snapshotpreview', component:SnapshotPreviewComponent},
  {path:'snapshot-output',component:OutputviewComponent},
  {path:'custom-snapshot-output',component:CustomOutputviewComponent},
  {
    path: AppConstants.barChartCategoryPathMap.chartModuleRoutePath,
    component: BarchartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/barchart/barchart-routing.module").then((barchart) => barchart.BarChartRoutingModule)
  },
  {
    path: AppConstants.barChartCategoryPathMap.chartModuleRoutePath,
    component: BarChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/barchart/barchart-routing.module").then((barchart) => barchart.BarChartRoutingModule)
  },
  {
    path: AppConstants.stackedBarChartCategoryPathMap.chartModuleRoutePath,
    component: StackedBarChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/stacked-bar-chart/stacked-bar-chart-routing.module").then((stackedchart) => stackedchart.StackedBarChartRoutingModule)
  },
  {
    path: AppConstants.stackedBarChartCategoryPathMap.chartModuleRoutePath,
    component: StackedBarChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/stacked-bar-chart/stacked-bar-chart-routing.module").then((stackedchart) => stackedchart.StackedBarChartRoutingModule)
  },
  {
    path: AppConstants.pieCategoryPathMap.chartModuleRoutePath,
    component: PieChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/pie-chart/pie-chart-routing.module").then((piechart) => piechart.PieChartRoutingModule)
  },
  {
    path: AppConstants.pieCategoryPathMap.chartModuleRoutePath,
    component: PieChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/pie-chart/pie-chart-routing.module").then((piechart) => piechart.PieChartRoutingModule)
  },
  {
    path: AppConstants.scatterCategoryPathMap.chartModuleRoutePath,
    component: ScatterChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/scatter-chart/scatter-chart-routing.module").then((scatterchart) => scatterchart.ScatterChartRoutingModule)
  },
  {
    path: AppConstants.scatterCategoryPathMap.chartModuleRoutePath,
    component: ScatterChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/scatter-chart/scatter-chart-routing.module").then((scatterchart) => scatterchart.ScatterChartRoutingModule)
  },
  {
    path: AppConstants.lollipopChartCategoryPathMap.chartModuleRoutePath,
    component: LollipopChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/lollipop-chart/lollipop-chart-routing.module").then((lollipopchart) => lollipopchart.LollipopChartRoutingModule)
  },
  {
    path: AppConstants.lollipopChartCategoryPathMap.chartModuleRoutePath,
    component: LollipopChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/lollipop-chart/lollipop-chart-routing.module").then((lollipopchart) => lollipopchart.LollipopChartRoutingModule)
  },
  {
    path: AppConstants.uniqueCategoryPathMap1.chartModuleRoutePath,
    component: UniqueChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/unique-chart/unique-chart-routing.module").then((uniquechart) => uniquechart.UniqueChartRoutingModule)
  },
  {
    path: AppConstants.uniqueCategoryPathMap1.chartModuleRoutePath,
    component: UniqueChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/unique-chart/unique-chart-routing.module").then((uniquechart) => uniquechart.UniqueChartRoutingModule)
  },
  {
    path: AppConstants.areaCategoryPathMap.chartModuleRoutePath,
    component: AreaChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/area-chart/area-chart-routing.module").then((areachart) => areachart.AreaChartRoutingModule)
  },
  {
    path: AppConstants.areaCategoryPathMap.chartModuleRoutePath,
    component: AreaChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/area-chart/area-chart-routing.module").then((areachart) => areachart.AreaChartRoutingModule)
  },
  {
    path: AppConstants.lineOrTrendCategoryPathMap.chartModuleRoutePath,
    component: LineOrTrendChartComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./modules/line-or-trend-chart/line-or-trend-chart-routing.module").then((linechart) => linechart.LineOrTrendChartRoutingModule)
  },
  {
    path: AppConstants.lineOrTrendCategoryPathMap.chartModuleRoutePath,
    component: LineOrTrendChartComponentCustom,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/line-or-trend-chart/line-or-trend-chart-routing.module").then((linechart) => linechart.LineOrTrendChartRoutingModule)
  },
  {
    path: AppConstants.TableCategoryPathMap.chartModuleRoutePath,
    component: TableViewComponent,
    //canActivate: [MsalGuard, MsalGuardCustom],
    loadChildren: () => import("./custom-snapshot-chart-modules/tableView/tableView-routing.module").then((Table) => Table.TableViewRoutingModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SnapshotRoutingModule { }
